<template>
    <div>
        <BodyAbout/>
    </div>
</template>

<script>
import BodyAbout from "../components/BodyAbout.vue"
export default {
    components:{
        BodyAbout
    }
}
</script>